import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function Paragraph(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return typeof props.children === "string" ? (
        <p
            className={props.className}
            dangerouslySetInnerHTML={{ __html: props.children }}
        />
    ) : (
        <p className={props.className}>{props.children}</p>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

Paragraph.propTypes = {
    className: PropTypes.string.isRequired,
    children: PropTypes.any,
}

Paragraph.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledParagraph = styled(Paragraph)`
    & {
        font-family: "Poppins-Regular";
        font-size: 20px;
        color: ${({ theme }) => theme?.colors?.textMuted};
    }
`
// ----------------------------------------------------------------------------

export default StyledParagraph
